import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Beaker24Regular } from '@fluentui/react-icons';
import { GuideEmptyState } from '../../../theme/components/GuideEmptyState';
import { GuideKpiCard } from '../../../theme/components/GuideKpiCard';
import { GuideCountChip } from '../../../theme/components/GuideKpiCard';
import { useProtocols } from '../Dashboard.Hooks';
import { WidgetProps } from '../Dashboard.Types';
import { WidgetData } from './WidgetData';
import { summarizeProtocols } from './Widgets.Functions';

/** Protocolos activos y cerrados, con los estados más frecuentes entre los activos. */
export const ActiveProtocolsWidget = (_props: WidgetProps) => {
  const { t } = useTranslation();
  const protocols = useProtocols();
  const summary = React.useMemo(() => summarizeProtocols(protocols.list), [protocols.list]);

  return (
    <WidgetData loading={protocols.loading} failed={protocols.failed} error={protocols.error} onRetry={protocols.reload} rows={3}>
      {summary.total === 0 ? (
        <GuideEmptyState icon={<Beaker24Regular />} title={t('dashboard.widgets.activeProtocols.empty')} data-testid="active-protocols-empty" />
      ) : (
        <div className="dbw-stack" data-testid="active-protocols">
          <div className="dbw-kpis dbw-kpis--compact">
            <Link to="/protocolsagreements/" className="dbw-kpis__link">
              <GuideKpiCard className="dbw-kpis__card" label={t('dashboard.widgets.activeProtocols.active')} value={summary.active} tone="success" valueTestId="active-protocols-active" />
            </Link>
            <Link to="/protocolsagreements/" className="dbw-kpis__link">
              <GuideKpiCard className="dbw-kpis__card" label={t('dashboard.widgets.activeProtocols.closed')} value={summary.closed} valueTestId="active-protocols-closed" />
            </Link>
            <Link to="/protocolsagreements/" className="dbw-kpis__link">
              <GuideKpiCard className="dbw-kpis__card" label={t('dashboard.widgets.activeProtocols.total')} value={summary.total} valueTestId="active-protocols-total" />
            </Link>
          </div>
          {summary.byStatus.length > 0 && (
            <div className="dbw-chips" aria-label={t('dashboard.widgets.activeProtocols.byStatus')}>
              <span className="dbw-chips__label">{t('dashboard.widgets.activeProtocols.byStatus')}</span>
              {summary.byStatus.map((item) => (
                <GuideCountChip key={item.title} label={item.title} count={item.count} />
              ))}
            </div>
          )}
        </div>
      )}
    </WidgetData>
  );
};

export default ActiveProtocolsWidget;
